import { render } from "./weekdays-headings.vue?vue&type=template&id=339102eb&lang=pug"
import script from "./weekdays-headings.vue?vue&type=script&lang=js"
export * from "./weekdays-headings.vue?vue&type=script&lang=js"

import "./weekdays-headings.vue?vue&type=style&index=0&id=339102eb&lang=scss"

import exportComponent from "/Users/matejglasnak/gitrepo/jandl/jandl-taskmanager-app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__